// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1HSyu","requiredAsterisk":"Info_requiredAsterisk__2OQQW"};